import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router-dom'

import {
  Layout,
  Header,
  Footer,
  Iconography,
  ContentSeparator
} from '@components'
import styles from './styles.module.scss'
import model from './model.en.json'

const DownloadT01App: FC<RouteComponentProps> = () => {
  const renderIconSection = () => {
    const appleT01Url = process.env.REACT_APP_T01_IOS_URL

    /** Note: Unknown link until release */
    const androidT01Url = process.env.REACT_APP_T01_ANDROID_URL

    return (
      <div className={styles.icons}>
        <Iconography
          id="t01-logo"
          name="t01Logo"
          extraClassName={styles.t01_logo}
        />
        <div className={styles.store_icons}>
          <a
            className={styles.link}
            href={appleT01Url}
            target="_blank"
            rel="noreferrer"
          >
            <Iconography id="t01-ios-store" name="t01IosStore" />
          </a>
          <a
            className={styles.link}
            href={androidT01Url}
            target="_blank"
            rel="noreferrer"
          >
            <Iconography id="t01-android-store" name="t01AndroidStore" />
          </a>
        </div>
      </div>
    )
  }

  const renderTextSection = () => {
    const supportUrl = process.env.REACT_APP_AKILI_ASSIST_URL

    return (
      <div className={styles.body_text}>
        <span>{model.bodyInfoStart}</span>
        <a
          className={styles.link}
          href={supportUrl}
          target="_blank"
          rel="noreferrer"
        >
          {model.bodyInfoLink}
        </a>
        <span>{model.bodyInfoEnd}</span>
      </div>
    )
  }

  return (
    <Layout>
      <div className={styles.container}>
        <Header title={model.title} description={model.description} />
        <div className={styles.body}>
          {renderIconSection()}
          <ContentSeparator extraClassName={styles.content_divider} />
          {renderTextSection()}
        </div>
        <Footer />
      </div>
    </Layout>
  )
}

export default DownloadT01App
